import DashboardClubGoals from './DashboardClubGoals';

export default DashboardClubGoals;
